import { Component, inject, input, linkedSignal, OnInit } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-load-animation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './load-animation.html',
})
export class LoadAnimation implements OnInit {
  // Dependencias
  private readonly dialogData = inject<{ size: string }>(DIALOG_DATA, { optional: true });

  // Inputs
  $_size = input<string>('50px', { alias: 'size' });
  $size = linkedSignal(this.$_size);

  ngOnInit(): void {
    if (this.dialogData)
      this.$size.set(this.dialogData.size);
  }
}
